import api from './api'

const fileMovementService = {
  // Get all file movements
  getMovements: (params) => api.get('/mrd/movement', { params }),

  // Get movement by ID
  getMovementById: (id) => api.get(`/mrd/movement/${id}`),

  // Get movements for a file
  getFileMovements: (fileId) => api.get(`/mrd/movement/file/${fileId}`),

  // Create new movement (maps to issueFile endpoint)
  createMovement: (data) => api.post('/mrd/movement/issue', data),

  // Return file movement
  returnMovement: (id, data) => api.post(`/mrd/movement/${id}/return`, data),

  // Update movement
  updateMovement: (id, data) => api.put(`/mrd/movement/${id}`, data),

  // Cancel movement
  cancelMovement: (id, reason) => api.post(`/mrd/movement/${id}/cancel`, { reason }),

  // Get pending movements (currently issued files)
  getPendingMovements: () => api.get('/mrd/movement/issued/current'),

  // Get overdue movements
  getOverdueMovements: () => api.get('/mrd/movement/issued/overdue'),

  // Get movement history
  getMovementHistory: (fileId) => api.get(`/mrd/movement/file/${fileId}`),

  // Bulk return
  bulkReturn: (movementIds, data) => api.post('/mrd/movement/bulk-return', {
    movementIds,
    ...data
  }),

  // Get movement statistics
  getMovementStats: () => api.get('/mrd/movement/stats/summary'),

  // Get dashboard data
  getDashboardData: () => api.get('/mrd/movement/dashboard/data'),

  // Get file locations
  getFileLocations: () => api.get('/mrd/movement/locations/list')
}

export default fileMovementService